import { z } from "zod";

/** docs/business-rules.md §6.6: jpeg/png/webp only, max 5 MB, max 5 per product. */
export const ALLOWED_MEDIA_CONTENT_TYPES = ["image/jpeg", "image/png", "image/webp"] as const;
export const MAX_MEDIA_FILE_SIZE_BYTES = 5 * 1024 * 1024;
export const MAX_PRODUCT_MEDIA_COUNT = 5;

export const requestMediaUploadUrlSchema = z.object({
  fileName: z.string().trim().min(1).max(255),
  contentType: z.enum(ALLOWED_MEDIA_CONTENT_TYPES),
  fileSize: z
    .number()
    .int()
    .min(1)
    .max(MAX_MEDIA_FILE_SIZE_BYTES),
});
export type RequestMediaUploadUrlInput = z.infer<typeof requestMediaUploadUrlSchema>;

export const mediaTypeSchema = z.enum(["IMAGE", "VIDEO"]);

export const confirmProductMediaSchema = z.object({
  fileKey: z.string().trim().min(1),
  mediaType: mediaTypeSchema,
  isPrimary: z.boolean().optional(),
  sortOrder: z.number().int().min(0).optional(),
  altText: z.string().trim().max(255).optional(),
  productVariantId: z.string().uuid().optional(),
});
export type ConfirmProductMediaInput = z.infer<typeof confirmProductMediaSchema>;

export const updateProductMediaOrderSchema = z.object({
  items: z
    .array(
      z.object({
        mediaId: z.string().uuid(),
        sortOrder: z.number().int().min(0),
        isPrimary: z.boolean(),
      }),
    )
    .min(1),
});
export type UpdateProductMediaOrderInput = z.infer<typeof updateProductMediaOrderSchema>;
